import { useMutation } from "react-query";
import { loggedInApiCall } from "src/api/axiosClient/userApi";

type Options = {
    payload: ActionPlanWrite;
};

export const useUpsertActionPlan = () => {
    // const queryClient = useQueryClient();

    const query = useMutation({
        mutationFn: async (options: Options) => {
            const { payload } = options;

            const url = `/api/action_plans`;

            const header = {
                "Content-Type": "application/json",
            };
            if (payload.id !== null) {
                const response = await loggedInApiCall.put(`${url}/${payload.id}`, payload, {
                    headers: header,
                });
                return response;
            }

            const response = await loggedInApiCall.post(url, payload, {
                headers: header,
            });
            return response;
        },
        // onSuccess: () => queryClient.invalidateQueries([getAllActionPlanKey]),
    });

    return query;
};

export type ActionPlanWrite = {
    id: string | null;
    name: string;
    description: string | null;
    simulationVaryPercentage: number | null;
    actionPlanScoreTargets: ActionPlanScoreTargetWrite[];
    startSsqPost: SsqPostWrite;
    endCampaign: CampaignWrite;
};

export type ActionPlanScoreTargetWrite =
    | IRI
    | {
          "@id"?: IRI;
          scoreId: number;
          variationId: number | null;
          simulationVaryPercentage: number | null;
          simulationVaryAbsolute: number | null;
      };

type SsqPostWrite = IRI;
type CampaignWrite = IRI;
